// extracted by mini-css-extract-plugin
export default {"base":"Accordeon_base__Cpxvs","header":"Accordeon_header__AxFEr","title":"Accordeon_title__LlupV","icon":"Accordeon_icon__j5nYE","content":"Accordeon_content__N7lfp"};